export default function TableWidget({
  columns,
  rows,
}: {
  columns: string[];
  rows: (string | number | boolean | null)[][];
}) {
  if (rows.length === 0) {
    return (
      <p className="text-sm text-foreground/40 font-medium">Sin datos.</p>
    );
  }

  return (
    <div className="h-full overflow-auto pr-1">
      <div
        className="grid gap-x-4 text-sm"
        style={{ gridTemplateColumns: `repeat(${columns.length}, minmax(0, 1fr))` }}
      >
        {columns.map((col) => (
          <div
            key={col}
            className="sticky top-0 bg-transparent pb-2 text-[10px] font-bold uppercase tracking-widest text-foreground/40 truncate"
            title={col}
          >
            {col}
          </div>
        ))}
        {rows.map((row, i) =>
          row.map((cell, j) => (
            <div
              key={`${i}-${j}`}
              className="border-t border-black/5 py-2 text-foreground/80 font-medium truncate"
              title={cell === null ? "" : String(cell)}
            >
              {cell === null ? "—" : String(cell)}
            </div>
          )),
        )}
      </div>
    </div>
  );
}
